import Card from '@trinsly/common/src/components/atoms/card'
import Column from '@trinsly/common/src/components/atoms/column'
import Heading from '@trinsly/common/src/components/atoms/heading'
import Separator from '@trinsly/common/src/components/atoms/separator'
import Text from '@trinsly/common/src/components/atoms/text'
import Button from '@trinsly/common/src/components/molecules/button'
import Modal from '@trinsly/common/src/components/molecules/modal'
import useRescheduleAllUnsentThreads from 'api-hooks/use-reschedule-all-unsent-threads'

export type RescheduleAllPausedReachOutsConfirmationModalProps = {
  visible: boolean
  onRequestClose: () => void
}

function RescheduleAllPausedReachOutsConfirmationModal({
  visible,
  onRequestClose,
}: RescheduleAllPausedReachOutsConfirmationModalProps) {
  const { fetch: rescheduleAllUnsentThreads, pending: pendingCancel } =
    useRescheduleAllUnsentThreads({
      onSuccess: (data) => {
        onRequestClose()
      },
      onError: () => alert('Failed to Reschedule All - Please Try Again'),
    })

  return (
    <Modal size="sm" visible={visible} onRequestClose={onRequestClose}>
      <Card className="overflow-hidden">
        <Column className="p-md">
          <Heading size="xl" fontWeight="bold">
            Reschedule all Paused Reach-Outs
          </Heading>
          <Separator size="sm" />
          <Text>
            Are you sure you want to reschedule all paused Reach-Outs?
          </Text>
        </Column>
        <Modal.Footer>
          <Button className="min-w-28" onClick={onRequestClose}>
            Close
          </Button>
          <Separator size="sm" />
          <Button
            className="min-w-48"
            intent="primary"
            pending={pendingCancel}
            onClick={() => {
              rescheduleAllUnsentThreads({})
            }}
          >
            Reschedule All
          </Button>
        </Modal.Footer>
      </Card>
    </Modal>
  )
}

export default RescheduleAllPausedReachOutsConfirmationModal
